module.exports = __webpack_public_path__ + "bin/495b22b6d9419a471408285942f6bbd9.svg";